// QR Kiosk v2 — nav-context helpers for the dynamic back mechanism (§7.1-A).
// The kiosk nav tree is STATIC; back targets are DECLARED per page (parent map in
// KV2_S7_EDITFLOW_DESIGN_SPEC.md §1.2), never discovered from a runtime history stack
// (a stack breaks on deep-link + refresh). Constants here are the single source so the
// "only the chrome header stays uncovered" contract can never drift.
export const KCHROME_H = 50; // chrome bar height — takeovers start below it
export const PILL_H = 48; // BackPill button height
export const BACK_CLEARANCE = 78; // in-flow spacer under content (existing value)
export const TAKEOVER_LIST_PAD = 88; // scroll-region bottom pad inside takeovers (pill + breathing)

export const menuPath = (internalNumber: string) => `/public-v2/machines/${internalNumber}`;

/** True when the path IS a machine dashboard (the "menu"). */
export const isMenuPath = (path: string) => /^\/public-v2\/machines\/[^/]+\/?$/.test(path);

/** The machine internal number when the path IS a machine dashboard (the QR target),
 *  else null. Single source for KioskEntryGate's chooser-vs-signin decision (KV2-T1). */
export const menuInternalNumber = (path: string): string | null => {
  const m = path.match(/^\/public-v2\/machines\/([^/]+)\/?$/);
  return m ? decodeURIComponent(m[1]) : null;
};
